"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SushiSwapV3Provider = void 0;
const chain_1 = require("@sushiswap/chain");
const LiquidityProvider_1 = require("./LiquidityProvider");
const UniswapV3Base_1 = require("./UniswapV3Base");
class SushiSwapV3Provider extends UniswapV3Base_1.UniswapV3BaseProvider {
    constructor(chainId, web3Client, databaseClient) {
        const factory = {
            [chain_1.ChainId.FANTOM]: '0x7770978eED668a3ba661d51a773d3a992Fc9DDCB',
            [chain_1.ChainId.OPTIMISM]: '0x9c6522117e2ed1fE5bdb72bb0eD5E3f2bdE7DBe0',
            [chain_1.ChainId.POLYGON]: '0x917933899c6a5F8E37F31E19f92CdBFF7e8FF0e2',
        };
        const initCodeHash = {
            [chain_1.ChainId.FANTOM]: '0xe34f199b19b2b4f47f68442619d555527d244f78a3297ea89325f843f87b8b54',
            [chain_1.ChainId.OPTIMISM]: '0xe34f199b19b2b4f47f68442619d555527d244f78a3297ea89325f843f87b8b54',
            [chain_1.ChainId.POLYGON]: '0xe34f199b19b2b4f47f68442619d555527d244f78a3297ea89325f843f87b8b54',
        };
        const tickLens = {
            [chain_1.ChainId.FANTOM]: '0xD75F5369724b513b497101fb15211160c1d96550',
            [chain_1.ChainId.OPTIMISM]: '0x0367a647A68f304f2A6e453c25033a4249d7F2C6',
            [chain_1.ChainId.POLYGON]: '0x9fdeA1412e50D78B25aCE4f96d35801647Fdf7dA',
        };
        super(chainId, web3Client, factory, initCodeHash, tickLens, databaseClient);
    }
    getType() {
        return LiquidityProvider_1.LiquidityProviders.SushiSwapV3;
    }
    getPoolProviderName() {
        return 'SushiSwapV3';
    }
}
exports.SushiSwapV3Provider = SushiSwapV3Provider;
//# sourceMappingURL=SushiSwapV3.js.map